import { SvgIcon, SvgIconProps } from "@/domains/icons/svg-icon"

export const ZapIcon = ({ ...rest }: SvgIconProps) => {
  return (
    <SvgIcon {...rest} strokeColor="currentColor" fillColor="currentColor">
      <path
        d="M13 2L3 14h9l-1 8 10-12h-9l1-8z"
        stroke="currentColor"
        fill="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </SvgIcon>
  )
}
